import { BusinessGoalDataApi } from "~/api/BusinessGoalData";

export function useBusinessGoalDataApi(): BusinessGoalDataApi {
    const businessGoalDataApi = new BusinessGoalDataApi(useHttpClient());
    
  return businessGoalDataApi;
}
